import { createSlice } from '@reduxjs/toolkit';
import { DEALERS_SLICE_PREFIX } from './constants';
import { fetchDealers } from './thunk';
const initialState = {};
const dealersSlice = createSlice({
    name: DEALERS_SLICE_PREFIX,
    initialState,
    reducers: {
        resetDealers() {
            return initialState;
        },
        setDealersByCountry(state, { payload }) {
            state[payload.country] = payload.dealers;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchDealers.fulfilled, (state, { payload, meta: { arg: { country }, }, }) => {
            state[country] = payload;
        });
    },
});
export const dealersReducer = dealersSlice.reducer;
export const dealersActions = dealersSlice.actions;
